import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

export enum CheckboxThemes {
  default = 'default',
  concrete = 'concrete',
}

@Component({
  selector: 'sd-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [FormsModule, ReactiveFormsModule],
  // Если положить чекбокс внутрь формы, затем задизейблить форму,
  // то чекбокс не дизейблится. Переключение на default стратегию
  // решает эту проблему.
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SdvorCheckboxComponent),
      multi: true,
    },
  ],
})
export class SdvorCheckboxComponent implements ControlValueAccessor {
  @Input() name: string;
  @Input() checked: boolean;
  @Input() theme: CheckboxThemes = CheckboxThemes.default;

  /**
   * В неактивном состоянии
   */
  @Input() @HostBinding('class.disabled') disabled = false;

  /**
   * Изменение состояния
   * ВНИМАНИЕ! change свойство у объекта эмитит Event, поэтому changed
   */
  @Output() changed = new EventEmitter<boolean>();

  @HostBinding('class')
  get classNames(): string[] {
    return ['sd-checkbox', this.theme && `sd-checkbox-theme-${this.theme}`].filter(Boolean);
  }

  private onChange: (_: any) => void;
  private onTouched: (_: any) => void;

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  inputOnChange(value: boolean): void {
    this.changed.emit(value);

    if (this.onChange) {
      this.onChange(value);
    }
    if (this.onTouched) {
      this.onTouched(value);
    }
  }
}
